export const fullBleedSplit = `background: bahaus
|
background: second
title: The Mississippi River Basin
subtitle: 41% of the continental United States drains through a single river system, carrying 145 million tonnes of sediment and 1.5 million tonnes of nitrogen to the Gulf of Mexico each year.
`